import { Adapter } from "./adapter";
var adapter = new Adapter();
export default adapter;
export { adapter };
